import { render } from "./export-pdf.vue?vue&type=template&id=0936d034&scoped=true&ts=true"
import script from "./export-pdf.vue?vue&type=script&lang=ts"
export * from "./export-pdf.vue?vue&type=script&lang=ts"

import "./export-pdf.vue?vue&type=style&index=0&id=0936d034&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0936d034"]])

export default __exports__